import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import AbilitiesService from 'donor-elf-web/services/abilities';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import TaskService from 'donor-elf-web/services/task-service';

export default class TaskV2IndexRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare router: RouterService;
  @service declare taskService: TaskService;

  beforeModel() {
    if (this.abilities.hasAbility('assign_tasks')) {
      this.router.transitionTo('funds.fund.tasks.v2.assigned');
    }

    this.navbarSettings.title = 'Tasks';
  }

  async model() {
    return this.taskService.load();
  }
}
